import {AbstractView} from "../../../views/AbstractView";
import {
  INavigatorBarController,
  IT_NAVIGATOR_BAR_CONTROLLER,
  MK_NAVIGATOR_BAR
} from "../_controllers/INavigatorBarController";
import {Component, input, OnInit} from "@angular/core";
import {NavigatorBarController} from "../_controllers/navigator-bar.controller";
import {NavigatorBarModel} from "../_models/NavigatorBarModel";
import {NavigatorBarItem} from "../_interfaces/NavigatorBarItem";

@Component({
  selector: 'link-navigator-bar',
  templateUrl: './navigator-bar.view.html',
  styleUrls: ['./navigator-bar.view.scss'],
  providers: [
    { provide: IT_NAVIGATOR_BAR_CONTROLLER, useClass: NavigatorBarController },
  ]
})
export class NavigatorBarView extends AbstractView<INavigatorBarController> implements OnInit {

  items = input<Array<NavigatorBarItem>>();

  protected readonly model: NavigatorBarModel;

  constructor() {
    super(IT_NAVIGATOR_BAR_CONTROLLER);

    this.model = this.getModel(MK_NAVIGATOR_BAR);
  }

  ngOnInit() {
    this.handle('Init', {
      items: this.items(),
    });
  }

  protected itemSelected(item: NavigatorBarItem, event: any): void {
    this.handle('ItemSelection', {
      item: item,
      event: event,
    });
  }
}
